import {Kullanici} from './kullanici';

export class GirisResponse {

  kullanici: Kullanici;
  token: string;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
    if (obj.kullanici) {
      this.kullanici = new Kullanici(obj.kullanici);
    }
  }

}
